import { FeatureToggleClientService } from 'feature-toggle-client';
const showPaymentsMenu = 'transact-show-payment-in-menu';
export class PaymentsFeatures {
    static IsPaymentsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showPaymentsMenu, false);
    }
}
